// extracted by mini-css-extract-plugin
export default {"button":"Button_button__9wPsX","primary":"Button_primary__67wHp","ghostLight":"Button_ghostLight__dFnND","ghostDark":"Button_ghostDark__fr86j"};